import { PlatformLocation } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import * as fromRoot from '@dav-store/reducers';
import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  loading$ = new BehaviorSubject<{ loading: boolean; hasError: boolean; hasMsg: string }>({
    loading: false,
    hasError: false,
    hasMsg: '',
  });

  initialloading$ = new BehaviorSubject<{ loading: boolean; hasError: boolean; hasMsg: string }>({
    loading: false,
    hasError: false,
    hasMsg: '',
  });

  error$ = new BehaviorSubject<{ status: string; message: string; show: boolean }>({
    status: '',
    message: '',
    show: false,
  });

  warning$ = new BehaviorSubject<{ status: string; message: string; show: boolean }>({
    status: '',
    message: '',
    show: false,
  });

  newVersion$ = new BehaviorSubject<{ status: string; message: string; show: boolean }>({
    status: '',
    message: '',
    show: false,
  });

  constructor(
    private router: Router,
    private platformLocation: PlatformLocation,
    private store$: Store<fromRoot.State>
  ) {}

  getCMSDealerNumber() {
    let cmsDealerNumber = '';
    this.store$
      .select((state) => state.userState.user)
      .subscribe((user) => {
        if (user) {
          cmsDealerNumber = user.cmsDealerNumber;
        }
      });

    return cmsDealerNumber;
  }

  /**
   * Request interceptor.
   */
  requestInterceptor(): void {
    this.loading$.next({ loading: true, hasError: false, hasMsg: '' });
  }

  /**
   * Response interceptor.
   */
  responseInterceptor(): void {
    this.loading$.next({ loading: false, hasError: false, hasMsg: '' });
  }

  /**
   * Request initial loading.
   */
  initialLoadingStart(): void {
    this.initialloading$.next({ loading: true, hasError: false, hasMsg: '' });
  }

  /**
   * Response initial loading.
   */
  initialLoadingStop(): void {
    this.initialloading$.next({ loading: false, hasError: false, hasMsg: '' });
  }

  displayErrorMessage(status: number, text: string) {
    this.error$.next({ status: status ? status.toString() : '', message: text, show: true });
  }

  hideErrorMessage() {
    this.error$.next({ status: '', message: '', show: false });
  }

  displayWarningMessage(status: number, text: string) {
    this.warning$.next({ status: status ? status.toString() : '', message: text, show: true });
  }

  hideWarningMessage() {
    this.warning$.next({ status: '', message: '', show: false });
  }

  displayNewVersionMessage() {
    this.newVersion$.next({ status: '', message: 'Application has been updated to the latest version', show: true });
  }

  hideNewVersionMessage() {
    this.newVersion$.next({ status: '', message: '', show: false });
  }

  getApiUrl(): string {
    return environment.apiUrl;
  }

  getDomainAndTypeFromUrl() {
    const hostName = this.extractHostname(window.location.hostname);
    const hs = this.splitHostname(hostName);
    if (hs.subdomain === 'landrover') {
      return 'landroverprotectioncom';
    }
    if (hs.subdomain.indexOf('mag-dealers') > -1) {
      return 'mag-dealersextraprotectcom';
    }

    return `${hs.domain}${hs.type}`;
  }

  getLanguage() {
    return localStorage.getItem('languageCode');
  }

  setLanguage(lang: string) {
    localStorage.setItem('languageCode', lang);
  }

  private extractHostname(url) {
    // find & remove protocol (http, ftp, etc.) and get hostname
    let hostname = url.indexOf('//') > -1 ? url.split('/')[2] : url.split('/')[0];
    // find & remove port number
    hostname = hostname.split(':')[0];
    // find & remove "?"
    hostname = hostname.split('?')[0];

    return hostname;
  }

  private splitHostname(hostName): any {
    const result = { domain: '', type: '', subdomain: '' };
    const regexParse = new RegExp('([a-z-0-9]{2,63}).([a-z.]{2,5})$');
    const urlParts = regexParse.exec(hostName);
    result.domain = urlParts[1];
    result.type = urlParts[2];
    result.subdomain = window.location.hostname.replace(result.domain + '.' + result.type, '').slice(0, -1);

    return result;
  }

  getDateLocale(language: string) {
    if (language === 'en-US' || language === 'en-CA') {
      return 'en';
    } else if (language === 'fr-CA') {
      return 'fr';
    }
  }
}
